// extracted by mini-css-extract-plugin
export default {"dev":"dev_dev__NdWHB","button":"dev_button__GbGa3","table":"dev_table__gZFZb","el":"dev_el__-c0Wm"};